import { useCallback, useState } from 'react';

import type { VirtualCreditCard } from '~/components/VirtualCreditCards/virtualCreditCards.types';

import OffersService from '~/services/OffersService';

import ApiError from '~/types/ApiError';

export const useFetchVirtualCreditCardsForCustomOffer = (customOfferId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [virtualCreditCards, setVirtualCreditCards] = useState<Array<VirtualCreditCard>>([]);

  const fetchVirtualCreditCards = useCallback(async () => {
    if (!customOfferId) {
      setVirtualCreditCards([]);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const response = await OffersService.getCustomOfferVendorVirtualCreditCards(customOfferId);
      setVirtualCreditCards(response.result);
      return response.result;
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) {
        setVirtualCreditCards([]);
      } else if (err instanceof ApiError && err.status === 403) {
        setError('You are not permitted to access this functionality.');
      } else {
        setError(err instanceof Error ? err.message : 'An error occurred');
      }
    } finally {
      setIsLoading(false);
    }
  }, [customOfferId]);

  return { virtualCreditCards, isLoading, error, fetchVirtualCreditCards };
};
